/**
 * External Imports
 */
import styled from 'styled-components';

// styled components
export const StyledCensusSVG = styled.svg`
  width: 100%;
  height: 100%;
  overflow: 'inherit';
`;
